import { FC, useEffect } from 'react';

import { fetchUsers } from 'components/Admin/Users/api/fetchUsers';
import { UsersFilter } from 'components/Admin/Users/UsersFilter/UsersFilter';
import { UsersTable } from 'components/Admin/Users/UsersTable/UsersTable';

import { useDispatch } from 'store/utils';

export const Users: FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        void dispatch(fetchUsers(true));
    }, [dispatch]);

    return (
        <>
            <UsersFilter />
            <UsersTable />
        </>
    );
};
